import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import trTr from 'antd/lib/locale/tr_TR';


import themes from 'devextreme/ui/themes';
import LocationViewer from './LocationViewer';

themes.initialized(() =>ReactDOM.render(
  <React.StrictMode>
      <ConfigProvider locale={trTr}>
    <App />
    {/* <LocationViewer>
    </LocationViewer> */}
  </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
